import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import React, { useEffect } from 'react';
import { TimeSpan, Body, Title } from './AboutToExpire.styles';
import { formatDuration } from '@innovyze/stylovyze/lib/utils';
// Separate component for avoiding forcing the user to logout when the component is unmounted
export default function AboutToExpireBody({ expiryDate, logout, }) {
    const expireTime = useForceExpire(expiryDate, logout);
    const { t } = useGlobalization();
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, null,
            t('For your security, you will be logged out in '),
            React.createElement(TimeSpan, null, JSON.stringify(expireTime))),
        React.createElement(Body, null, t('If you are still working and don’t want to end your session, click the extend session button below. Otherwise, your session will be closed and you will be logged out.'))));
}
function useForceExpire(expiryDate, logout) {
    const [expireTime, setExpireTime] = React.useState(expiryDate?.diffNow?.()?.toFormat('mm:ss') || '');
    // Set the timeout number and handle logout when it expires
    useEffect(() => {
        const interval = setInterval(async () => {
            // Set timeout formatted string
            const diff = expiryDate?.diffNow();
            diff.milliseconds <= 0
                ? setExpireTime('00:00')
                : setExpireTime(formatDuration(diff));
            // Handle logout when timeout expires
            if (diff.milliseconds <= 0) {
                logout();
                // await to let the logout finish before clearing the timeout
                await new Promise(resolve => setTimeout(resolve, 2000));
                clearInterval(interval);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [expiryDate]);
    return expireTime;
}
